import { getStartedDocumentation } from './documentation';

export const GetStarted = () => {
  return (
    <>
      {getStartedDocumentation.map((doc) => (
        <div id={doc.id} key={doc.id}>
          {doc.content}
        </div>
      ))}
    </>
  );
};
